"use client"; // QueryClient is for client requests only

import type { PropsWithChildren, ReactNode } from "react";

import {
  QueryCache,
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useMemo } from "react";

import { logger } from "@/src/infrastructure/datadog/Datadog";

// https://tanstack.com/query/v5/docs/framework/react/guides/ssr
// https://codevoweb.com/setup-react-query-in-nextjs-13-app-directory/
export function QueryClientProvider({
  children,
}: PropsWithChildren): ReactNode {
  const client = useMemo(
    () =>
      new QueryClient({
        defaultOptions: { queries: {} },
        queryCache: new QueryCache({
          onError: (error, query): void => {
            logger.error("TanStack Query error", query, error);
          },
        }),
      }),
    [],
  );

  // By default, React Query Devtools are only included in bundles when process.env.NODE_ENV === 'development',
  // so you don't need to worry about excluding them during a production build.
  return (
    <TanstackQueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </TanstackQueryClientProvider>
  );
}
